<mat-sidenav-container #sidenav class="sidenav-container">
  <mat-toolbar class="toolbar">
    <p class="title">Givaudan</p>
    <app-icon [svgIcon]="'mobileMenuClose'" [class]="'closeIcon'" (click)="onToggleClose()"></app-icon>
  </mat-toolbar>
  <mat-nav-list class="nav-list">
    <a
      routerLink="/who-we-are"
      mat-list-item
      class="body-m"
      (click)="onToggleClose()"
      >{{ 'header.who-we-are' | translate }}</a
    >
    <div class="fragrances-menu-mobile" mat-list-item>
      <mat-accordion>
        <mat-expansion-panel
          (opened)="fragranceMenuOpenState = true"
          (closed)="fragranceMenuOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ 'header.fragrances' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="links">
            @for (link of fragrancesLinks; track link.href) {
              <a
                (click)="goToLink('/edito/' + link.href, $event)"
                class="body-m simple-link">
                {{ 'simple-link-names.fragrances.' + link.name | translate }}</a>
            }
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <a
      mat-list-item
      class="body-m"
      (click)="onToggleClose()"
      [routerLink]="'/trends-inspirations'"
      >{{ 'header.trends-and-inspiration' | translate }}</a
    >
    <a
    mat-list-item
    class="body-m"
    (click)="onToggleClose()"
    [routerLink]="'/protected/fragrance-catalogue'"
    >{{ 'header.fragrance-catalogue' | translate }}</a
  >
  </mat-nav-list>
  <div class="separator-line"></div>
  <div class="container-welcome">
    <mat-toolbar class="toolbar-title">
      <app-icon [svgIcon]="'account'" [class]="'account-icon'"></app-icon>
      <p class="body-m title">Account</p>
    </mat-toolbar>
    @if (!accountService.user().isAuthenticated) {
      <mat-nav-list
        class="container-welcome__btn">
        <app-button
          (click)="onToggleClose()"
          [size]="'medium'"
          [width]="'full'"
          routerLink="/register"
          data-testid="btn-signup"
          type="secondary"
          [text]="'header.sign-up' | translate">
        </app-button>
        <app-button
          (click)="onToggleClose(); login()"
          [size]="'medium'"
          [width]="'full'"
          data-testid="btn-login"
          type="tertiary"
          [text]="'header.login' | translate">
        </app-button>
      </mat-nav-list>
    } @else {
      <mat-nav-list
        class="container-welcome__btn">
        <div class="manage-account-menu-mobile" mat-list-item>
          <mat-accordion>
            <mat-expansion-panel
              (opened)="accountMenuOpenState = true"
              (closed)="accountMenuOpenState = false">
              <mat-expansion-panel-header>
                <mat-panel-title class="body-m">
                  {{ 'header.manage-account' | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div *appFeatureToggling="'requests-v1'">
                @for (link of manageAccountLinks; track link) {
                  <a
                    [routerLink]="['/protected/' + link.href]"
                    (click)="onToggleClose()"
                    class="manage-account-items">
                    <app-icon [icon]="link.icon"  [class]="'icon-s custom-icon-size'"></app-icon>
                    <p class="body-m">
                      {{'simple-link-names.manage-account.' + link.name | translate }}
                    </p>
                  </a>
                }
              </div>
              <div *appFeatureToggling="'requests-v2'">
                @for (link of manageAccountLinksV2; track link) {
                  <a
                    [routerLink]="['/protected/' + link.href]"
                    (click)="onToggleClose()"
                    class="manage-account-items">
                    <app-icon [icon]="link.icon"  [class]="'icon-s custom-icon-size'"></app-icon>
                    <p class="body-m">
                      {{'simple-link-names.manage-account.' + link.name | translate }}
                    </p>
                  </a>
                }
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
        <app-button *appFeatureToggling="'requests-v1'"
          (click)="onToggleClose()"
          [size]="'medium'"
          [width]="'full'"
          routerLink="/protected/cart"
          data-testid="btn-login"
          type="secondary"
          [text]="'header.open-basket' | translate">
        </app-button>
        <app-button *appFeatureToggling="'requests-v2'"
          (click)="onToggleClose()"
          [size]="'medium'"
          [width]="'full'"
          routerLink="/protected/cart/V2"
          data-testid="btn-login"
          type="secondary"
          [text]="'header.open-basket' | translate">
        </app-button>
        <app-button
          (click)="logout()"
          [size]="'medium'"
          [width]="'full'"
          data-testid="btn-login"
          type="tertiary"
          [text]="'header.logout' | translate">
        </app-button>
      </mat-nav-list>
    }
  </div>
  <div class="separator-line" *appFeatureToggling="'allLocalAvailable'"></div>
  <div class="container-welcome" *appFeatureToggling="'allLocalAvailable'">
    <mat-toolbar class="toolbar-title">
      <app-icon [svgIcon]="'language'"  [class]="'account-icon'"></app-icon>
      <p class="body-m title">Language</p>
    </mat-toolbar>

    @if (translateFileLoaded) {
      <mat-select
        panelClass="app-header__local-dropdown"
        disableOptionCentering
        class="form-input form-locale"
        [hideSingleSelectionIndicator]="true"
        [multiple]="false"
        [(value)]="selectedLocal"
        [formControl]="preferredLanguage">
        @for (locale of locales; track locale) {
          <mat-option [value]="locale">
            {{ 'locales-mobile.' + locale | translate }}
          </mat-option>
        }
      </mat-select>
    }
  </div>
</mat-sidenav-container>
